import _slicedToArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _styled from "styled-components";
import React, { useState, useMemo } from "react";
import { MenuContext } from "./MenuContext";
import { Menu } from "./Menu";

var Content = _styled.div.withConfig({
  displayName: "MenuContainer__Content",
  componentId: "sc-1h4ab3b-0"
})(["position:absolute;width:100%;height:100%;overflow-x:hidden;overflow-y:", ";background-color:white;transform:translateX(", ");transition:transform 0.2s ease-in-out;z-index:3;box-shadow:0px 0px 20px 15px #6d99d0;"], function (p) {
  return p.menuIsActive ? "hidden" : "auto";
}, function (p) {
  return p.menuIsActive ? "-260px" : "0";
});

var MenuLayer = _styled.div.withConfig({
  displayName: "MenuContainer__MenuLayer",
  componentId: "sc-1h4ab3b-1"
})(["position:absolute;z-index:2;background-color:white;width:250px;top:0;right:0;height:100%;"]);

var ContentInner = _styled.div.withConfig({
  displayName: "MenuContainer__ContentInner",
  componentId: "sc-1h4ab3b-2"
})(["position:relative;background-color:white;min-height:100%;z-index:3;display:flex;flex-direction:column;align-items:stretch;justify-content:stretch;"]);

var Overlay = _styled.div.withConfig({
  displayName: "MenuContainer__Overlay",
  componentId: "sc-1h4ab3b-3"
})(["position:absolute;top:0;left:0;width:100%;height:100%;z-index:", ";transition:backdrop-filter 0.2s ease-in-out,z-index 0s linear ", ";pointer-events:", ";"], function (p) {
  return p.menuIsActive ? "4" : "1";
}, function (p) {
  return !p.menuIsActive ? "0.2s" : "0s";
}, function (p) {
  return p.menuIsActive ? "unset" : "none";
});

export function MenuContainer(_ref) {
  var _ref$menu = _ref.menu,
      menu = _ref$menu === void 0 ? [] : _ref$menu,
      children = _ref.children;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      menuIsActive = _useState2[0],
      setMenuIsActive = _useState2[1];

  var menuApi = useMemo(function () {
    return {
      toggle: function toggle() {
        return setMenuIsActive(function (a) {
          return !a;
        });
      },
      close: function close() {
        return setMenuIsActive(false);
      },
      open: function open() {
        return setMenuIsActive(true);
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuLayer, null, /*#__PURE__*/React.createElement(Menu, {
    menuApi: menuApi,
    menu: menu
  })), /*#__PURE__*/React.createElement(Content, {
    menuIsActive: menuIsActive
  }, /*#__PURE__*/React.createElement(ContentInner, null, /*#__PURE__*/React.createElement(MenuContext.Provider, {
    value: menuApi
  }, children), /*#__PURE__*/React.createElement(Overlay, {
    menuIsActive: menuIsActive,
    onMouseDown: menuApi.close,
    onTouchStart: menuApi.close
  }))));
}